module.exports = __webpack_public_path__ + "static/media/Diagram-Library.b56b6954.png";